import React, { ReactElement, VFC, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { TestID } from '../../utils/PropTypesDefinitions'
import { PaddingProps } from '../../utils/styling/StylingHelper'
import { BackgroundColorTypes } from '../../Theme/Fonts/FontTypes'

export type DividerProps = {
    /**
     * sets the color to black
     * */
    dark?: boolean
    /**
     * sets a backgroundcolor behind the line, often used if padding is set
     * */
    backgroundColor?: BackgroundColorTypes
} & Omit<PaddingProps, 'paddingX' | 'paddingY'> &
    TestID

const Divider: VFC<DividerProps> = ({
    dark,
    backgroundColor,
    testID,
    ...paddingProps
}): ReactElement => (
    <Grid
        noExpand
        horizontal
        width="100%"
        backgroundColor={backgroundColor}
        testID={testID}
        {...paddingProps}
    >
        <Grid backgroundColor={dark ? 'moon-5' : 'tahitian-3'} height={1} />
    </Grid>
)

export default memo(Divider)
